import React, { useEffect, useState } from "react";
import { DatePicker, Space } from "antd";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { getLeadsCountAPI } from "../API/Api";
import { formBtn1, formBtn2, pageClass } from "../Components/Utils/CustomClasses";
import {
  IconBriefcase,
  IconPhoneCall,
  IconStopwatch,
  IconPhoneCalling,
  IconSquareRoundedX,
} from "@tabler/icons-react";
import { LEAD_STATUS_CONFIG , DEFAULT_STATUS_CONFIG } from "../Components/Utils/StaticData";
import BarLoader from "../Components/Loader/BarLoader";

export default function Dashboard() {
  const { control, reset, handleSubmit  } = useForm();
  const { RangePicker } = DatePicker;
  const [leadCount, setLeadCount] = useState({});
  const [cardsLoading, setCardsLoading] = useState(true);
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });
  const navigate = useNavigate();
  const UserDetails = useSelector((state) => state?.login?.userDetails);

  const handleNavigate = (title) => {
    const formattedTitle = title.trim();
    navigate(`/total-leads`, {
      state: { title: formattedTitle, dateRange, from: "dashboard" },
    });
  };

  const fetchLeadsCount = async (data) => {
    try {
      setCardsLoading(true);
      let response = await getLeadsCountAPI({
        id: UserDetails?._id,
        role: UserDetails?.role?.roleName,
        startDate: data?.startDate,
        endDate: data?.endDate,
        company:
          UserDetails?.role?.roleName === "SuperAdmin"
            ? ""
            : UserDetails?.company?._id,
      });
      setLeadCount(response?.data);
    } catch (error) {
      console.error("Error in fetching count data:", error);
      setLeadCount({});
    }finally {
    setCardsLoading(false);
  }
  };
  useEffect(() => {
    fetchLeadsCount({
      startDate: "",
      endDate: "",
    });
  }, []);

  const onSubmit = (data) => {
    let startDateFormatted = "";
    let endDateFormatted = "";
    if (data?.rangeDate != undefined && data?.rangeDate?.length != 0) {
      const startDate = `${data?.rangeDate[0].$D}-${
        data?.rangeDate[0].$M + 1
      }-${data?.rangeDate[0].$y}`;
      const endDate = `${data?.rangeDate[1].$D}-${data?.rangeDate[1].$M + 1}-${
        data?.rangeDate[1].$y
      }`;
      startDateFormatted = moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD");
      endDateFormatted = moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    const UpdatedData = {
      startDate: startDateFormatted,
      endDate: endDateFormatted,
    };
    setDateRange(UpdatedData);
    fetchLeadsCount(UpdatedData);
  }

  const onClear = () => {
    reset({
      rangeDate: null, // Reset date range picker
    });
    fetchLeadsCount({
      startDate: "",
      endDate: "",
    });
  };
  return (
    <>
      {cardsLoading ? (
        <>
            <div className={`${pageClass}`}>
              <BarLoader />
            </div>        
        </>
            ) : (
            <div className={`${pageClass}`}>
              <div className="bg-[#FDFDFD] shadow rounded-xl p-8">
                  <div className="flex justify-between items-center">
                    <p className="text-3xl font-bold text-base-color ">
                      Call Status Overview
                    </p>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="flex items-center gap-3">
                        <div>
                          <Space direction="vertical" size={12}>
                            <Controller
                              name="rangeDate"
                              control={control}
                              render={({ field }) => (
                                <RangePicker
                                  {...field}
                                  className="w-[300px] h-[48px] rounded-lg border border-[#DFDFDF] bg-[#F9FAFB] px-3 shadow-none hover:shadow-none focus:shadow-none"
                                  value={field.value}
                                  placeholder={["Start date", "End date"]}
                                />
                              )}
                            />
                          </Space>
                        </div>
                        <div>
                          <div className="flex gap-2 justify-end flex-shrink-0 items-center">
                              <button
                                type="submit"
                                className={`${formBtn1}`}
                              // disabled={isApplyDisabled}
                            >
                              Apply
                            </button>
                          
                            <button
                              type="button"
                              onClick={onClear}
                                className={`${formBtn2} `}
                              // disabled={isApplyDisabled}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                

                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-[40px] mb-4 px-1">
                      {leadCount?.dynamicStatus?.map((item, index) => {

                    const statusName = Object.keys(item)[0];
                    const statusCount = Object.values(item)[0];

                    const config = LEAD_STATUS_CONFIG[statusName] || DEFAULT_STATUS_CONFIG;

                    const Icon = config.icon;
                    const bgColor = config.bg;
                    const iconColor = config.color;

                    return (
                      <div
                        key={index}
                        className="rounded-3xl flex justify-start items-center gap-4 p-4 sm:p-6 border-2 cursor-pointer"
                        onClick={() => handleNavigate(statusName)}
                      >

                        <div className={`${bgColor} rounded h-12 w-12 sm:h-16 sm:w-16 flex justify-center items-center`}>
                          <Icon size={40} color={iconColor} />
                        </div>

                        <div className="flex flex-col">
                          <p className="text-lg sm:text-xl font-semibold text-[#90A1B9]">
                            {statusName}
                          </p>

                          <p className="text-xl sm:text-2xl font-bold text-gray-800">
                            {statusCount}
                          </p>
                        </div>
                      </div>
                    );
                  })}

                </div>
              </div>

              <div className="bg-[#FFFFFF] shadow py-4 px-4 rounded">
                <div className="text-left">
                  <div className="flex items-center gap-4">
                    <h3 className="text-3xl text-base-color font-bold">
                      Statistics
                    </h3>
                  </div>
                  <p className="text-lg text-gray-600">
                    Your statistics for{" "}
                    <span className="font-bold text-base-color">till now</span>
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
                  <div
                    className="bg-[#F4F2FE] border-[#DCD5FD] p-4 h-[145px] rounded cursor-pointer"
                    onClick={() => handleNavigate("Total Leads")}
                  >
                    <div className="flex flex-col gap-3">
                      <div className="bg-[#6D28D8] rounded w-16 h-16 flex justify-center items-center">
                        <IconPhoneCall size="40" color="#ffffff" />
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-lg font-bold text-gray-600">Total Leads</p>
                        <p className="text-xl font-semibold text-[#6D28D8]">
                          {leadCount?.FixStatus?.TotalLeads || 0}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className="bg-[#FEF9C2] border border-[#FFF085] p-4 h-[145px] rounded cursor-pointer"
                    onClick={() => handleNavigate("Pending")}
                  >
                    <div className="flex flex-col gap-3">
                      <div className="bg-[#F0B100] rounded w-16 h-16 flex justify-center items-center">
                        <IconStopwatch size="46" color="#ffffff" />
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-lg font-bold text-gray-600">Pending Leads</p>
                        <p className="text-xl font-semibold text-[#F0B100]">
                          {leadCount?.FixStatus?.Pending || 0}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className="bg-[#F0FDF4] border border-[#B9F8CF] p-4 h-[145px] rounded cursor-pointer"
                    onClick={() => handleNavigate("DealDone")}
                  >
                    <div className="flex flex-col gap-3">
                      <div className="bg-[#008236] rounded w-16 h-16 flex justify-center items-center">
                        <IconBriefcase size={40} color="#ffffff" />
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-lg font-bold text-gray-600">Deal Done</p>
                        <p className="text-xl font-semibold text-[#008236]">
                          {leadCount?.FixStatus?.DealDone || 0}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="bg-[#FEF2F2] border border-[#FFC9C9] p-4 h-[145px] rounded cursor-pointer"
                    onClick={() => handleNavigate("Rejected")}
                  >
                    <div className="flex flex-col gap-3">
                      <div className="bg-[#C10007] rounded w-16 h-16 flex justify-center items-center">
                        <IconSquareRoundedX size={40} stroke={2} color="#FFFFFF"/>
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-lg font-bold text-gray-600">
                          Rejected
                        </p>
                        <p className="text-xl font-semibold text-[#C10007]">
                          {leadCount?.FixStatus?.Rejected || 0}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
    
    </>
  );
}
